import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AllianceService } from './alliance.service';
import { Alliance } from 'src/app/shared/models/alliance.model';

@Component({
  selector: 'app-alliance',
  templateUrl: './alliance.component.html',
  styleUrls: ['./alliance.component.scss']
})
export class AllianceComponent implements OnInit, OnDestroy {

  isbn: string;
  titles: Alliance[];
  private searchSubscription: Subscription = null;

  constructor(private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private allianceService: AllianceService) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.searchSubscription !== null) { this.searchSubscription.unsubscribe(); }
  }

  onSearch(term: string) {
    this.isbn = term;
    this.search();
  }

  search(): void {

    this.spinner.show();

    this.searchSubscription = this.allianceService.searchTitle(this.isbn).subscribe((result: any) => {

      this.titles = result;

      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
      console.error(error);
    });

  }

}
